// src/common/dateUtils.ts

/**
 * Safely formats a date string to 'DD MMM YYYY' (e.g., '04 Nov 2025').
 * Returns '-' if invalid or missing.
 */
export function safeFormatDate(dateString?: string): string {
  if (!dateString) return "-";
  const safeDate = dateString.endsWith("Z") ? dateString : dateString + "Z";
  const date = new Date(safeDate);
  if (isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}
